














import Vue from 'vue';
import Create from './Create.vue';
import GroupList from './GroupList.vue';

export default Vue.extend({
  data() {
    return {
    };
  },
  components: {
    Create,
    GroupList,
  },
  methods: {
    handleGroupCreated() {
      (this.$refs['groupList'] as any).loadRemarkGroups();
    },
  },
});
